export const SIDEBAR_JOB_STATUS_POLL_INTERVAL_MS = 1_000;
export const JOB_STATUS_CARDS_POLL_INTERVAL_MS = 10_000;

export const formatDuration = (seconds?: number | null): string => {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) {
    return "Unavailable";
  }

  const rounded = Math.max(0, Math.round(seconds));
  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  const remainingSeconds = rounded % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  }

  return `${remainingSeconds}s`;
};

export const formatEta = (seconds?: number | null): string =>
  seconds === null || seconds === undefined
    ? "unavailable"
    : formatDuration(seconds);

export const formatJobCount = (count: number): string =>
  `${count} ${count === 1 ? "job" : "jobs"}`;

export const getJobProgressPercent = (
  elapsedSeconds?: number | null,
  averageDurationSeconds?: number | null
): number | null => {
  if (
    elapsedSeconds === null ||
    elapsedSeconds === undefined ||
    averageDurationSeconds === null ||
    averageDurationSeconds === undefined ||
    averageDurationSeconds <= 0
  ) {
    return null;
  }

  return Math.max(
    0,
    Math.min(100, Math.round((elapsedSeconds / averageDurationSeconds) * 100))
  );
};

export const formatScheduledAt = (value?: string | null): string => {
  if (!value) {
    return "Scheduled time unavailable";
  }

  const scheduledAt = new Date(value);
  if (Number.isNaN(scheduledAt.getTime())) {
    return "Scheduled time unavailable";
  }

  const absoluteTime = new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(scheduledAt);
  const secondsUntilScheduled = Math.round(
    (scheduledAt.getTime() - Date.now()) / 1000
  );

  if (secondsUntilScheduled > 0) {
    return `Scheduled for ${formatDuration(secondsUntilScheduled)} from now (${absoluteTime})`;
  }

  if (secondsUntilScheduled > -60) {
    return `Scheduled for now (${absoluteTime})`;
  }

  return `Scheduled ${formatDuration(Math.abs(secondsUntilScheduled))} ago (${absoluteTime})`;
};
